/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedautonachrueckenenabled3Inputs */

const en__field_inheritedautonachrueckenenabled3 = /** @type {(inputs: _Field_Inheritedautonachrueckenenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`automatic moveup enabled (derived)`)
};

const de__field_inheritedautonachrueckenenabled3 = /** @type {(inputs: _Field_Inheritedautonachrueckenenabled3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`auto Nachrücken aktiv (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "automatic moveup enabled (derived)" |
*
* @param {_Field_Inheritedautonachrueckenenabled3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedautonachrueckenenabled3 = /** @type {((inputs?: _Field_Inheritedautonachrueckenenabled3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedautonachrueckenenabled3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedautonachrueckenenabled3(inputs)
	return de__field_inheritedautonachrueckenenabled3(inputs)
});
export { _field_inheritedautonachrueckenenabled3 as "_field_inheritedAutoNachrueckenEnabled" }